import api from '@/utils/api'

export default {

  actions: {
    async loadAdminStatistics(_, {data}) {
      const res = await api.http.post('admin/admin-statistics', data)
      return res?.data
    },
    async loadActions() {
      const res = await api.http.get('admin/admin-actions')
      return res?.data
    },

  },
  namespaced: true,
}

